import { useEffect, useState } from 'react';
import { FTS0004_GROUP_PARAMETER_KEY, FTS0004_GROUP_PARAMETER_OPTIONS, FTS0004_TREATMENT_KEY, PARAMETERS } from '../constants/experimentKeys';
import { laboratoryClient } from '../utils/laboratoryUtil';
export const logFTS0004Exposure = () => {
  laboratoryClient.logExposure(FTS0004_TREATMENT_KEY);
};

// https://tools.hubteam.com/laboratory/experiments/edit/fts-0004?tab=workflow&step=0
export const useIsFTS0004Control = shouldShowRemoveBrandingMessage => {
  const [isFTS0004Control, setIsFTS0004Control] = useState(false);
  const [isFTS0004Fetched, setIsFTS0004Fetched] = useState(false);
  useEffect(() => {
    if (!isFTS0004Fetched) {
      if (shouldShowRemoveBrandingMessage) {
        laboratoryClient.resolve(treatments => {
          if (Object.keys(treatments).length) {
            const treatment = treatments[FTS0004_TREATMENT_KEY];
            const cohort = treatment[PARAMETERS][FTS0004_GROUP_PARAMETER_KEY];
            const isControl = cohort === FTS0004_GROUP_PARAMETER_OPTIONS.control;
            setIsFTS0004Control(isControl);
          }
          setIsFTS0004Fetched(true);
          logFTS0004Exposure();
        });
      } else {
        setIsFTS0004Control(false);
        setIsFTS0004Fetched(true);
      }
    }
  }, [isFTS0004Fetched, shouldShowRemoveBrandingMessage]);
  return {
    isFTS0004Control,
    isFTS0004Fetched
  };
};